<template>
  <div class="container">
    <HeadInfo></HeadInfo>
    <div class="tipSty">
      <div>
        本周概要（{{ filterTime(weekData.week_start) }}-{{
          filterTime(weekData.week_end)
        }}）
      </div>
    </div>
    <DurationStudy :particulas="weekData"></DurationStudy>
  </div>
</template>

<script>
import DurationStudy from "./components/DurationStudy.vue";
import HeadInfo from "./components/HeadInfo.vue";
import { entertainmenttime } from "@/api/squirrelCup";

export default {
  data() {
    return {
      perInfo: {},
      weekData: {},
    };
  },
  components: {
    DurationStudy,
    HeadInfo,
  },
  mounted() {
    this.perInfo = JSON.parse(localStorage.getItem("headInfo"));
    this.queryEntertainmenttime();
  },
  methods: {
    queryEntertainmenttime() {
      let week_start = this.$route.query.week_start;
      let param = {
        account_id: Number(this.perInfo.accountId),
        week: Number(week_start),
      };

      entertainmenttime({ param }).then((res) => {
        console.log(res);
        this.weekData = res.data;
      });
    },
    filterTime(value) {
      let dateString = String(value) || "******";
      let year = dateString?.substring(0, 4);
      let month = dateString?.substring(4, 6);
      let day = dateString?.substring(6, 8);
      return `${month}.${day}`;
    },
  },
};
</script>
<style scoped lang="less">
.container {
  margin: 0px 32px;
  margin-top: 40px;
  .tipSty {
    display: flex;
    justify-content: space-between;
    font-size: 32px;
    margin-bottom: 16px;
    margin-top: 40px;
  }
}
</style>
